import { useContext } from 'react';

import { ModalCoordinationContext } from './ModalCoordinationContext';

export const useModalCoordinationContext = () => {
  const context = useContext(ModalCoordinationContext);
  if (!context) {
    throw new Error('useModalCoordinationContext must be used within a ModalCoordinationProvider');
  }
  return context;
};
